import { render } from "./WhyAStrick.vue?vue&type=template&id=0531dc66&scoped=true"
import script from "./WhyAStrick.vue?vue&type=script&lang=js"
export * from "./WhyAStrick.vue?vue&type=script&lang=js"

import "./WhyAStrick.vue?vue&type=style&index=0&id=0531dc66&scoped=true&lang=css"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0531dc66"]])

export default __exports__